import FormGroup from "features/shared/forms/components/FormGroup";
import FormGroupTooltip from "features/shared/forms/components/formGroup/FormGroupTooltip";
import React from "react";

interface Props {
  label?: string;
  defaultValueLabel?: string;
  defaultValueLabelDisabled?: boolean;
  name: string;
  value?: string | number;
  options: any[];
  optionName?: string;
  optionValue?: string;
  optionNameConvert?: (optionNameValue: string) => string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  validationError?: string;
  visible?: boolean;
  className?: string;
  classNameSelect?: string;
  reactKey?: React.Key;
  tooltip?: FormGroupTooltip;
  disabled?: boolean;
}

const SelectInput = (props: Props) => {
  const renderItems = (): JSX.Element[] => {
    let result: JSX.Element[] = [];

    if (props.options.length === 0) return result;

    if (props.defaultValueLabel && (props.value === undefined || props.value === null || props.value === "")) {
      result.push(
        <option
          key={0}
          value=""
          hidden
          disabled={props.defaultValueLabelDisabled}
          className={props.defaultValueLabelDisabled ? "d-none" : undefined}
        >
          {props.defaultValueLabel ?? ""}
        </option>
      );
    }

    props.options.map((val, i) => {
      result.push(
        <option key={i + 1} value={val[getOptionValue()]}>
          {getOptionNameValue(val[getOptionName()])}
        </option>
      );
    });

    return result;
  };

  const getOptionNameValue = (value: string) => {
    if (props.optionNameConvert) {
      return props.optionNameConvert(value);
    } else {
      return value;
    }
  };

  const getOptionName = (): string => {
    // if name is not specifed => OptionType is automatically used
    return props.optionName ? props.optionName : "name";
  };

  const getOptionValue = (): string => {
    // if name is not specifed => OptionType is automatically used
    return props.optionValue ? props.optionValue : "value";
  };

  return (
    <FormGroup
      key={props.reactKey}
      inputId={props.name}
      labelText={props.label}
      validationError={props.validationError}
      visible={props.visible}
      className={props.className}
      tooltip={props.tooltip}
    >
      <select
        id={props.name}
        name={props.name}
        value={props.value}
        className={`custom-select${
          props.classNameSelect ? " " + props.classNameSelect : ""
        }`}
        onChange={props.onChange}
        disabled={props.disabled}
      >
        {renderItems()}
      </select>
    </FormGroup>
  );
};

export default SelectInput;
